export const environment = {
  APIBaseURL: "https://pastebin1s.com/api/",
  Separator:
    "++++++++++[>++++++>++++++++>++++++>+++++++<<<<-]>>.<.>+++++++.>>.>+.<<+++++.>>.<++++++.>.>+.>>.<<+++++.>>.>++++++.>.<+++++++.>.<<<++++++.>.<++++++.>.<++++++.>.",
};
